import { Component, effect, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { FilterHeaderComponent } from '../filter-header/filter-header.component';
import { BaseFilterComponent } from '../filter/base-filter.component';

@Component({
  selector: 'vectronic-single-dropdown-filter',
  templateUrl: './single-select-filter.component.html',
  styleUrls: ['./single-select-filter.component.scss'],
  imports: [FilterHeaderComponent, MatSelectModule, MatFormFieldModule, ReactiveFormsModule],
})
export class SingleSelectFilterComponent extends BaseFilterComponent {
  @ViewChild(MatSelect) private matSelect: MatSelect;

  // noinspection JSUnusedGlobalSymbols
  focusFilterInputOnShow = effect(() => {
    if (this.isFilterHidden()) {
      setTimeout(() => this.matSelect?.open());
    }
  });
}
